import React from 'react';
interface GenderSelectionProps {
  gender: string;
  onGenderChange: (gender: string) => void;
}
const GenderSelection: React.FC<GenderSelectionProps> = ({
  gender,
  onGenderChange
}) => {
  return <div className="bg-[#e3f2fd] p-4 rounded-lg mb-5 text-center" data-id="element-12">
      <h3 className="text-lg font-semibold mb-2" data-id="element-13">
        👤 Gender Selection (for questions 59 & 60)
      </h3>
      <div className="flex justify-center gap-5 mt-2.5" data-id="element-14">
        <label className="flex items-center cursor-pointer" data-id="element-15">
          <input type="radio" name="gender" value="female" checked={gender === 'female'} onChange={() => onGenderChange('female')} className="mr-1.5" data-id="element-16" />
          Female
        </label>
        <label className="flex items-center cursor-pointer" data-id="element-17">
          <input type="radio" name="gender" value="male" checked={gender === 'male'} onChange={() => onGenderChange('male')} className="mr-1.5" data-id="element-18" />
          Male
        </label>
      </div>
    </div>;
};
export default GenderSelection;